export default {
    data() {
        return {
            works:
                {
                    "city-of-galala": {
                        name: "مشاريع مدينه الجلاله",
                        id: "city-of-galala",
                    },
                    "the-capital": {
                        name: "مشاريع العاصمه الاداريه",
                        id: "the-capital",
                    },
                    "taxes": {
                        name: "مشاريع مصلحه الضرائب",
                        id: "taxes",
                    },
                    "others": {
                        name: "مشاريع متنوعه",
                        id: "others",
                    },
                },
            projects: {
                "city-of-galala": {
                    "1": {
                        name: "مشروع انشاء الكورنيش",
                        id: "1",
                        photo: "",
                        photos: [],
                    },
                    "2": {
                        name: "مشروع مسجد الكورنيش",
                        id: "2",
                        photo: "",
                        photos: [],
                    },
                    "3": {
                        name: "مشروع صيانه الكورنيش",
                        id: "3",
                        photo: "",
                        photos: [],
                    },
                    "4": {
                        name: "مشروع زراعه الكورنيش",
                        id: "4",
                        photo: "",
                        photos: [],
                    },
                    "5": {
                        name: "مشروع المطعم الحلزوني",
                        id: "5",
                        photo: "",
                        photos: [],
                    },
                    "6": {
                        name: "مشروع المحلات الدائرية",
                        id: "6",
                        photo: "",
                        photos: [],
                    },
                    "7": {
                        name: "مشروع مطعم اللسان",
                        id: "7",
                        photo: "",
                        photos: [],
                    },
                    "8": {
                        name: "مشروع كيدزاريا",
                        id: "8",
                        photo: "",
                        photos: [],
                    },
                    "9": {
                        name: "مشروع مطعم تبه التليفريك",
                        id: "9",
                        photo: "",
                        photos: [],
                    },
                    "10": {
                        name: "مشروع غرفه المحولات",
                        id: "10",
                        photo: "",
                        photos: [],
                    },
                    "11": {
                        name: "مشروع زراعه كيدزاريا",
                        id: "11",
                        photo: "",
                        photos: [],
                    },
                    "12": {
                        name: "مشروع شاليهات 13 و 14 خرسانات",
                        id: "12",
                        photo: "",
                        photos: [],
                    },
                    "13": {
                        name: "مشروع شاليهات 13 و 14 تشطيبات",
                        id: "13",
                        photo: "",
                        photos: [],
                    },
                    "14": {
                        name: "مشروع شاليهات 13 و 14 صحي",
                        id: "14",
                        photo: "",
                        photos: [],
                    },
                    "15": {
                        name: "مشروع شاليهات 13 و 14 لاندسكيب",
                        id: "15",
                        photo: "",
                        photos: [],
                    },
                    "16": {
                        name: "مشروع انشاء دبش ريزورت 5",
                        id: "16",
                        photo: "",
                        photos: [],
                    },
                    "17": {
                        name: "مشروع فيلات ريزورت 5",
                        id: "17",
                        photo: "",
                        photos: [],
                    },
                    "18": {
                        name: "مشروع 2 فيلا ملحق مع فيلات ريزورت 5",
                        id: "18",
                        photo: "",
                        photos: [],
                    },
                    "19": {
                        name: "مشروع انشاء وتشطيب مبني 6 الدوان تاون",
                        id: "19",
                        photo: "",
                        photos: [],
                    },
                    "20": {
                        name: "مشروع انشاء وتشطيب مبني 7 الدوان تاون",
                        id: "20",
                        photo: "",
                        photos: [],
                    },
                    "21": {
                        name: "مشروع انشاء وتشطيب مبني 8 الدوان تاون",
                        id: "21",
                        photo: "",
                        photos: [],
                    },
                    "22": {
                        name: "مشروع انشاء مسجد الحي السكني",
                        id: "22",
                        photo: "",
                        photos: [],
                    },
                    "23": {
                        name: "مشروع انشاء مسجد الداون تاون",
                        id: "23",
                        photo: "",
                        photos: [],
                    },
                    "24": {
                        name: "مشروع انشاء مبني 32",
                        id: "24",
                        photo: "",
                        photos: [],
                    },
                    "25": {
                        name: "مشروع لاندسكيب الداون تاون",
                        id: "25",
                        photo: "",
                        photos: [],
                    },

                },

                "the-capital": {
                    "1": {
                        name: "فيلات الكيان",
                        id: "1",
                        photo: "",
                        photos: [],
                    },
                    "2": {
                        name: "ساحه الشعب",
                        id: "2",
                        photo: "",
                        photos: [],
                    },
                    "4": {
                        name: "مسجد العاصمه",
                        id: "4",
                        photo: "",
                        photos: [],
                    }, "5": {
                        name: "موقف الحافلات",
                        id: "5",
                        photo: "",
                        photos: [],
                    },
                },

                "taxes": {
                    "1": {
                        name: "مستشفي العاملين بمصلحه الضرائب (التجمع الاول)",
                        id: "1",
                        photo: "",
                        photos: [],
                    }, "2": {
                        name: "مأمورية ضرائب مكرم عبيد",
                        id: "2",
                        photo: "",
                        photos: [],
                    }, "3": {
                        name: "مأمورية ضرائب امبابة اول وثان",
                        id: "3",
                        photo: "",
                        photos: [],
                    }, "4": {
                        name: "مأمورية ضرائب وادي النيل",
                        id: "4",
                        photo: "",
                        photos: [],
                    }, "5": {
                        name: "مأمورية ضرائب الوايلي والظاهر",
                        id: "5",
                        photo: "",
                        photos: [],
                    }, "6": {
                        name: "مأمورية ضرائب كفرشكر",
                        id: "6",
                        photo: "",
                        photos: [],
                    }, "7": {
                        name: "مأمورية ضرائب طوخ",
                        id: "7",
                        photo: "",
                        photos: [],
                    }, "8": {
                        name: "مأمورية ضرائب بركة السبع",
                        id: "8",
                        photo: "",
                        photos: [],
                    }, "9": {
                        name: "مأمورية ضرائب الاسماعيليه",
                        id: "9",
                        photo: "",
                        photos: [],
                    }, "10": {
                        name: "مأمورية ضرائب وادي حلفا",
                        id: "10",
                        photo: "",
                        photos: [],
                    }, "11": {
                        name: "مأمورية ضرائب ميت غمر اول وثان",
                        id: "11",
                        photo: "",
                        photos: [],
                    }, "12": {
                        name: "مأمورية ضرائب اجا",
                        id: "12",
                        photo: "",
                        photos: [],
                    }, "13": {
                        name: "مأمورية ضرائب المنصورة ثان",
                        id: "13",
                        photo: "",
                        photos: [],
                    }, "14": {
                        name: "مأمورية ضرائب طلخا ومنطقه الدقهليه ثان ومباحث التهرب الضريبي",
                        id: "14",
                        photo: "",
                        photos: [],
                    }, "15": {
                        name: "مأمورية ضرائب دكرنس",
                        id: "15",
                        photo: "",
                        photos: [],
                    }, "16": {
                        name: "مأمورية ضرائب فارسكور",
                        id: "16",
                        photo: "",
                        photos: [],
                    }, "17": {
                        name: "مشاريع احلال وتجديد مصاعد ضرائب الزيتون والمحمودي ومكرم عبيد",
                        id: "17",
                        photo: "",
                        photos: [],
                    },
                },

                "others": {
                    "1": {
                        name: "مدرسه اللغات بجاردينيا",
                        id: "1",
                        photo: "",
                        photos: [],
                    },
                    "2": {
                        name: "المدرسه اليابانيه بجاردينيا",
                        id: "2",
                        photo: "",
                        photos: [],
                    },
                    "3": {
                        name: "استاد الفيوم الرياضي",
                        id: "3",
                        photo: "",
                        photos: [],
                    },
                    "4": {
                        name: "جمعيه عباد الهادي",
                        id: "4",
                        photo: "",
                        photos: [],
                    }, "5": {
                        name: "رفع كفاءه المدينه الجامعيه جامعه القاهره",
                        id: "4",
                        photo: "",
                        photos: [],
                    }, "6": {
                        name: "رفع كفاءه مسجد المشير طنطاوي",
                        id: "4",
                        photo: "",
                        photos: [],
                    },
                },
            },
        }
    },

}